import Vue from 'vue';

import get from 'lodash/get';
import keys from 'lodash/keys';
import reduce from 'lodash/reduce';

export default {
   props: [ 'selected' ],
   created() {
      this.selectedAsMap = _convertToMap(this.selected);
   },
   data() {
      return {
         selectedAsMap: {}
      };
   },
   methods: {
      valueForOption(option) {
         return get(this.selectedAsMap, option.id, false);
      },
      onChangeOption(option, val) {
         if (val) {
            this.selectedAsMap[option.id] = val;
         } else {
            delete this.selectedAsMap[option.id];
         }
         Vue.set( this, 'selectedAsMap', this.selectedAsMap );
         this.$emit('change', keys(this.selectedAsMap));
      },
      reselect(selectedAsMap) {
         this.selectedAsMap = selectedAsMap;
         this.$emit('change', keys(this.selectedAsMap));
      },
      only(option) {
         this.selectedAsMap = {};
         this.onChangeOption(option, true);
      }
   },
   watch: {
      selected(selected) {
         this.selectedAsMap = _convertToMap(selected);
      }
   }
};

function _convertToMap(list) {
   return reduce(list, (memo, id) => {
      memo[id] = true;
      return memo;
   }, {});
}
